import { getFileByFirebaseStorageLinkAsync } from '../services/ImageService';

export const transformObjectPropertyLowercase = (objectToTransform: any) => {
  const transformedObject = {};
  Object.keys(objectToTransform).forEach((key) => {
    const lowercaseKey = key.charAt(0).toLowerCase() + key.slice(1);
    // @ts-ignore
    transformedObject[lowercaseKey] = objectToTransform[key];
  });
  return transformedObject;
};

export const transformSecondsInMilliseconds = (seconds: number) => {
  return seconds * 1000;
};

export const transformMillisecondsInSeconds = (seconds: number) => {
  return seconds / 1000;
};

export const convertBase64ToBlob = (
  base64: string,
  contentType = 'image/png',
) => {
  const byteCharacters = window.atob(
    base64.replace(/^data:[a-z]+\/[a-z]+;base64,/, ''),
  );
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
};

export const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result.toString().split(',')[1]);
      } else {
        reject(new Error('Failed to convert Blob to Base64'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const transformDataUrlToFile = (dataurl: string, filename: string) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const transformToUTC = (date: any) => {
  const localDate = new Date(date);
  return new Date(
    Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate(),
      localDate.getHours(),
      localDate.getMinutes(),
      localDate.getSeconds(),
    ),
  ).toISOString();
};

export const transformDateStringInDate = (dateString: string): Date => {
  const [datePart, timePart] = dateString.split(' ');
  const [month, day, year] = datePart.split('/').map(Number);
  const [hours, minutes, seconds] = timePart.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
};

export const transformHtmlToPlainText = (html: string) => {
  return html
    .replace(/<p><br><\/p>/g, '\n')
    .replace(/<p>/g, '')
    .replace(/<\/p>/g, '\n')
    .replace(/<br\s*\/?>/g, '\n')
    .replace(/<h1>/g, '# ')
    .replace(/<h2>/g, '## ')
    .replace(/<\/h[1-6]>/g, '\n')
    .replace(/<strong>|<b>/g, '*')
    .replace(/<\/strong>|<\/b>/g, '*')
    .replace(/<em>|<i>/g, '_')
    .replace(/<\/em>|<\/i>/g, '_')
    .replace(/<ul>/g, '')
    .replace(/<\/ul>/g, '')
    .replace(/<li>/g, '- ')
    .replace(/<\/li>/g, '\n')
    .replace(/<ol>/g, '')
    .replace(/<\/ol>/g, '')
    .replace(/<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g, '[$2]($1)')
    .replace(/<[^>]+>/g, '')
    .trim();
};

export const transformPlainTextToHtml = (text: string) => {
  return text
    .replace(/\n{2,}/g, '</p><p>')
    .replace(/\n/g, '<br>')
    .replace(/^# (.*)$/gm, '<h1>$1</h1>')
    .replace(/^## (.*)$/gm, '<h2>$1</h2>')
    .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
    .replace(/_(.*?)_/g, '<em>$1</em>')
    .replace(/^- (.*)$/gm, '<li>$1</li>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/(<li>.*<\/li>)/g, '<ul>$1</ul>');
};

export const transformFirebaseLinkToBlob = async (
  firebaseUrl?: string,
): Promise<Blob | string> => {
  if (!firebaseUrl) return '';

  try {
    const response = await getFileByFirebaseStorageLinkAsync(firebaseUrl);
    
    if (!response || (response instanceof Blob && response.size === 0)) {
      console.warn(`[Aviso] Imagem ausente (204 No Content): ${firebaseUrl}`);
      return ''; 
    }
    
    return response;
  } catch (error: any) {
    console.error("Erro inesperado ao buscar a imagem:", error);
    return ''; 
  }
};
